import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { ViewButton } from "../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { getCheckedShiftDetails } from "../../../../redux/features/trasportationSlice";
import {
  Box,
  Skeleton,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import DatePickerCustom from "../../../../components/DatePicker/DatePickerCustom";
import dayjs from "dayjs";
import useResponsive from "../../../../Hooks/useResponsive";

//SHIFT IDS AS DEFINED IN THE BACKEND (transportation.controller.js -> transportShiftIds = [3,4])
const SHIFTS = {
  MORNING: 3,
  EVENING: 4,
  ALL: "ALL",
};

/**
 * pick the shift matching the current time,
 * used as the default selection every time the popup is opened
 * @author Akhil E M
 * @createdAt 03-08-2026
 * @updates 03-08-2026(Akhil EM),
 * @type function
 * @packages dayjs
 * @returns {number} shift id
 */
const getShiftForCurrentTime = () => {
  const hour = dayjs().hour();
  //FROM 7 PM THE VIEW ALREADY SHOWS THE NEXT DAY AND MORNING SHIFT BOOKING OPENS (BACKEND SHIFT WINDOW STARTS 20:00)
  if (hour >= 19) return SHIFTS.MORNING;
  //BEFORE NOON IT IS MORNING , AFTER NOON IT IS EVENING
  return hour < 12 ? SHIFTS.MORNING : SHIFTS.EVENING;
};

const SeatAvailability = ({ date }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [direction, setDirection] = useState("row");
  const [shift, setShift] = useState(getShiftForCurrentTime);
  const smDown = useResponsive("down", "sm");

  useEffect(() => {
    if (smDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [smDown]);
  const [selectedDate, setSelectedDate] = useState(date);
  const { checkedShiftData, loading } = useSelector(
    (store) => store.transportation
  );

  useEffect(() => {
    if (open) {
      //GETTING THE SHIFT AND ITS AVAILABLITY STATUSES , NO SHIFT ID SENT WHEN "ALL" IS SELECTED
      dispatch(
        getCheckedShiftDetails({
          shiftId: shift === SHIFTS.ALL ? undefined : shift,
          date: date,
        })
      );
    }
  }, [open, date, shift]);

  const getGradientColor = (remaining, capacity) => {
    const percentage = (remaining / capacity) * 100; // Remaining capacity in percentage
    if (percentage >= 50) {
      // Light green gradient
      return `rgba(144, 238, 144, ${(percentage / 100) * 0.9 + 0.1})`;
    } else {
      // Light red gradient
      return `rgba(255, 182, 193, ${(1 - percentage / 100) * 0.9 + 0.1})`;
    }
  };

  return (
    <GlobalDialog
      maxWidth={"md"}
      fullWidth
      title={`Seat Status For ${date}`}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      popupButton={
        <ViewButton
          size={smDown ? "small" : "large"}
          action={() => {
            setShift(getShiftForCurrentTime()); //AUTO SELECT THE SHIFT BASED ON CURRENT TIME ON EVERY OPEN
            setOpen(true);
          }}
        >
          Seat Status
        </ViewButton>
      }
      content={
        <Box>
          {/* SHIFT FILTER , DEFAULTED FROM THE CURRENT TIME AND OVERRIDABLE BY THE USER */}
          <ToggleButtonGroup
            size="small"
            exclusive
            fullWidth={smDown}
            value={shift}
            onChange={(event, value) => {
              if (value !== null) setShift(value); //KEEPS ONE OPTION ALWAYS SELECTED
            }}
            aria-label="shift filter"
            sx={{ mb: 2 }}
          >
            <ToggleButton value={SHIFTS.MORNING}>Morning Shift</ToggleButton>
            <ToggleButton value={SHIFTS.EVENING}>Evening Shift</ToggleButton>
            <ToggleButton value={SHIFTS.ALL}>All</ToggleButton>
          </ToggleButtonGroup>

          {loading ? (
          <Stack
            gap={1}
            sx={{
              width: "100%",
              justifyContent: "space-between",
              padding: 2,
            }}
          >
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={50}
                animation="wave"
                sx={{
                  borderRadius: 1,
                }}
              />
            ))}
          </Stack>
        ) : checkedShiftData?.length > 0 ? (
          <Box>
            {/* <Box sx={{mb:1}}>
                <DatePickerCustom
                  disabled
                //   fullWidth={true}
                  value={dayjs(selectedDate)}
                  setValue={(date) =>
                    setSelectedDate(date.format("YYYY-MM-DD"))
                  }
                  viewDetails={["year", "month", "day"]}
                  error={false}
                />
              </Box> */}
            {checkedShiftData?.map((data) => (
              <Box
                key={data?.slotId}
                sx={{
                  display: "flex",
                  flexDirection: smDown ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 2,
                  mb: 1,
                  borderRadius: 1,
                  backgroundColor: getGradientColor(
                    data?.remainingCapacity,
                    data?.slotCapacity
                  ),
                  color: "text.primary", // Dark text color
                  boxShadow: 1, // Light shadow for better contrast
                }}
              >
                <Typography variant="overline">{data?.slotName}</Typography>
                <Typography variant="overline">
                  Available : {data?.remainingCapacity}
                </Typography>
                <Typography variant="overline">
                  Max Capacity : {data?.slotCapacity}
                </Typography>
                
              </Box>
            ))}
          </Box>
        ) : (
          <Typography>No Data Available</Typography>
        )}
        </Box>
      }
    />
  );
};

export default SeatAvailability;
